import React from "react";
import Responsive from "react-responsive";
import Calendar from "pages/Calendar";
import MobileCalendarView from "components/Calendars/Mobile/MobileCalendarView";
import Layout from "components/Layout";
import Modal from "components/Modal";

/** Alineado con `Layout` (988px): mismo rango que el menú hamburguesa / sidebar estrecho. */
const CALENDAR_MOBILE_MAX_WIDTH_PX = 987;

const CalendarMobile = (props) => (
	<Responsive {...props} maxWidth={CALENDAR_MOBILE_MAX_WIDTH_PX} />
);
const CalendarDesktop = (props) => (
	<Responsive {...props} minWidth={CALENDAR_MOBILE_MAX_WIDTH_PX + 1} />
);

const CalendarResponsive = (props) => {
	return (
		<>
			<CalendarDesktop>
				<Calendar {...props} />
			</CalendarDesktop>
			<CalendarMobile>
				<Layout context="calendar">
					<MobileCalendarView />
				</Layout>
				<Modal />
			</CalendarMobile>
		</>
	);
};

export default CalendarResponsive;
